'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchOwners = undefined;

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cachedResult = null;

var fetchOwners = exports.fetchOwners = function fetchOwners() {
  if (cachedResult !== null) {
    return cachedResult;
  }

  cachedResult = _apiClient2.default.get('self-service/v2/owner');

  return cachedResult;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/api/fetchOwners.js
// module id = 471
// module chunks = 3 4 5